var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlignCenter48Line = function SvgIconAlignCenter48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 11.3H11v3.4h26v-3.4ZM33 18.63H15v3.4h18v-3.4ZM37 25.97H11v3.4h26v-3.4ZM30 33.3H18v3.4h12v-3.4Z",
    fill: "current"
  })));
};
export default SvgIconAlignCenter48Line;